export default __webpack_public_path__ + "static/media/extreme-plan.84cf9b19.png";